<template>
  <v-layout wrap>
    <v-flex
      xs12
      md6
      px-2
    >
      <money-input
        v-model="method.price"
        :label="$t('Price')"
        :disabled="netDisabled"
      />
    </v-flex>

    <template v-if="tax_type === 'vat'">
      <v-flex
        xs12
        md6
        px-2
      >
        <money-input
          v-model="method.gross_price"
          :label="$t('Gross Price')"
          :disabled="grossDisabled"
        />
      </v-flex>
      <v-flex
        xs12
        md6
        px-2
      >
        <v-select
          v-if="taxes.length > 0"
          v-model="method.vat"
          :disabled="!vat_enabled"
          :label="$t('VAT')"
          :item-text="vatLabel"
          :items="taxes"
          item-value="id"
          return-object
          outline
        />
      </v-flex>
    </template>

    <v-flex
      xs12
      md6
      px-2
    >
      <v-select
        v-model="method.price_type"
        :items="priceTypes"
        :error-messages="method.displayErrors('price_type')"
        :label="$t('Price type')"
        item-text="name"
        item-value="type"
        outline
      />
    </v-flex>
  </v-layout>
</template>

<script>
import Money from 'js-money'
import { mapGetters } from 'vuex'
import MoneyInput from '@/components/form/MoneyInput'

export default {
  name: 'ShippingPrice',

  components: {
    MoneyInput
  },

  props: {
    method: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      default: () => {}
    },
    taxes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      vat_enabled: this.settings && this.settings.type && this.settings.type === 'vat',
      vat_in_price: this.settings.vat_in_price || false,
      tax_type: this.settings.type || 'sales'
    }
  },

  computed: {
    ...mapGetters(['currency']),

    priceTypes () {
      return [
        { type: 'per_item', name: this.$t('Per item') },
        { type: 'fixed', name: this.$t('Fixed') }
      ]
    },

    netDisabled () {
      return this.vat_enabled && this.vat_in_price
    },

    grossDisabled () {
      return (this.vat_enabled && !this.vat_in_price) || !this.vat_enabled
    }
  },

  watch: {
    'method.price': function () {
      this.recalculateGross(this.method.price, 'gross_price')
    },

    'method.gross_price': function () {
      this.recalculateNet(this.method.gross_price, 'price')
    },

    'method.vat': function () {
      if (this.grossDisabled) {
        this.recalculateGross(this.method.price, 'gross_price')
      }

      if (this.netDisabled) {
        this.recalculateNet(this.method.gross_price, 'price')
      }
    }
  },

  methods: {
    vatLabel (vat) {
      return `${vat.name} (${vat.value}%)`
    },

    recalculateGross (sourcePrice, destField) {
      if (this.tax_type === 'sales' && typeof sourcePrice === 'object') {
        this.method[destField] = sourcePrice
        return
      }

      if (sourcePrice === null || !this.method.vat || this.netDisabled) {
        return
      }

      sourcePrice = new Money(sourcePrice.amount, sourcePrice.currency)

      const vat = this.method.vat.value / 100
      this.method[destField] = sourcePrice.add(sourcePrice.multiply(vat))
    },

    recalculateNet (sourcePrice, destField) {
      if (sourcePrice === null || !this.method.vat || this.grossDisabled) {
        return
      }

      sourcePrice = new Money(sourcePrice.amount, sourcePrice.currency)

      const vat = this.method.vat.value / 100
      this.method[destField] = sourcePrice.subtract(sourcePrice.multiply(vat).divide(vat + 1))
    }
  }
}
</script>
